<template>
    <div class="leverage-and-margin" :class="$t('Dividend.box-name')">
        <page-navigate></page-navigate>
        <section class="flex items-start leverage-margin_header">
            <div class="leverage-margin_main">
                <h1 class="leverage-margin_title super_large-80_bold md-title-32_bold">
                    杠杆与保证金
                </h1>
                <h2 class="leverage-margin_desc subtitle-20_regular md-body-14_regular">
                    在EBC，可以自由选择杠杆大小。但是鉴于金融市场的不确定性和潜在的巨幅波动，要根据自己的风险偏好合理选择杠杆
                </h2>
                <a :href="signupUrl" target="_blank">
                    <div class="leverage-margin_btn primary-default_large cursor-pointer">
                        <span>开始交易</span>
                        <span class="iconfont icon-right"></span>
                    </div>
                </a>
            </div>
            <img src="@/assets/image/LeverageAndMargin/leverage-margin-model.png" alt=""
                class="leverage-margin_model" />
        </section>
        <div style="background: #ebebeb">
            <section class="superLever">
                <div class="superLever-title flex items-center justify-center scroll-fade-up">
                    <img src="@/assets/image/LeverageAndMargin/whiteStar.svg" alt="" />
                    <span class="title-48_bold md-title-24_bold word1">超级杠杆</span>
                    <img src="@/assets/image/LeverageAndMargin/whiteStar.svg" alt="" />
                </div>
                <div
                    class="superLever-desc subtitle-20_regular md-footnote-regular_12 text-center scroll-fade-up word3">
                    当交易外汇和贵金属类交易产品时，EBC为特定国家和地区的客户提供超级杠杆交易方案，最大限度提升资金使用效率
                </div>
                <div class="superLever-cardList flex">
                    <div class="superLever-card-left scroll-fade-left">
                        <div class="superLever-card-title subtitle-20_medium md-body-16_medium flex items-center">
                            <img src="@/assets/image/LeverageAndMargin/superlever-cardIcon1.svg" alt="" />
                            <span class="word4">两种选择</span>
                        </div>
                        <div class="superLever-card-desc body-16_regular md-body-14_regular word5">
                            使用真实账号交易时，符合条件的客户可申请超级杠杆，最大杠杆<br class="pc">高至 1
                            : 无限
                        </div>
                        <div class="superLever-card-leverTypeList flex">
                            <div class="superLever-card-leverType">
                                <div class="body-14_regular md-footnote-regular_12 swWord word7">
                                    可申请杠杆
                                </div>
                                <div class="title-40_bold md-title-32_bold superLever-card-leverTypeNum">
                                    1:2000
                                </div>
                                <div class="body-14_regular md-body-14_regular swWord">
                                    <span class="word6">净值范围 (USD)</span>：500.01 - 2000
                                </div>
                                <img src="@/assets/image/LeverageAndMargin/superlever-bgNumer1.svg" alt=""
                                    class="innerNumberBg" />
                            </div>
                            <div class="superLever-card-leverType">
                                <div class="body-14_regular md-footnote-regular_12 swWord word7">
                                    可申请杠杆
                                </div>
                                <div class="title-40_bold md-title-32_bold superLever-card-leverTypeNum word8">
                                    1:无限
                                </div>
                                <div class="body-14_regular md-body-14_regular swWord">
                                    <span class="word6">净值范围 (USD)</span>：0 - 500
                                </div>
                                <img src="@/assets/image/LeverageAndMargin/superlever-bgNumer2.svg" alt=""
                                    class="innerNumberBg" />
                            </div>
                        </div>
                    </div>
                    <div class="superLever-card-right scroll-fade-right">
                        <div class="superLever-card-rightTop">
                            <div class="superLever-card-title subtitle-20_medium md-body-16_medium flex items-center">
                                <img src="@/assets/image/LeverageAndMargin/superlever-cardIcon2.svg" alt="" />
                                <span class="word9">自动匹配</span>
                            </div>
                            <div class="superLever-card-desc body-16_regular md-body-14_regular word10">
                                申请成功后，EBC会根据账号净值自动匹配杠杆级别，无需繁琐步骤
                            </div>
                        </div>
                        <div class="superLever-card-rightBottom">
                            <div class="superLever-card-title subtitle-20_medium md-body-16_medium flex items-center">
                                <img src="@/assets/image/LeverageAndMargin/superlever-cardIcon3.svg" alt="" />
                                <span class="word11">灵活风控</span>
                            </div>
                            <div class="superLever-card-desc body-16_regular md-body-14_regular word12">
                                超级杠杆允许最大 200 笔订单上限（含持仓与挂单），净值＜0
                                自动平仓，实现资金利用效率与市场风险控制的动态均衡
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center scroll-fade-up">
        <a href="https://support.ebchelp.com/hc/zh-cn/articles/52134837974553-%E8%B6%85%E7%BA%A7-%E6%97%A0%E9%99%90%E6%9D%A0%E6%9D%86%E8%A7%84%E5%88%99" target="_blank" class="superLeverBtn">
          <span class="content-16_medium">
            了解更多
          </span>
          <span class="iconfont icon-right"></span>
          </a>
          </div>
            </section>
        </div>
        <section class="safe-trading">
            <h2 class="safe-trading-title title-48_bold md-title-24_bold contentBox text-center scroll-fade-up">标准杠杆
            </h2>
            <h3
                class="safe-trading-desc subtitle-20_regular md-footnote-regular_12 contentBox text-center scroll-fade-up">
                请谨慎考虑您的投资目标及风险承受能力，选择适合的杠杆比例。<br> 为了更好地实现风险管控，请参考下表，了解每项资产的保证金要求和最大杠杆</h3>
            <div class="floatTab flex justify-center items-center scroll-fade-up">
                <div class="tabItem text-center cursor-pointer body-16_regular active word1">
                    衍生品
                </div>
                <div class="tabItem text-center cursor-pointer body-16_regular word2">
                    贵金属及能源
                </div>
                <div class="tabItem text-center cursor-pointer body-16_regular word3">
                    全球股指
                </div>
                <div class="tabItem text-center cursor-pointer body-16_regular word4">
                    美国股票
                </div>
                <div class="tabItem text-center cursor-pointer body-16_regular word4">
                    ETF
                </div>
                <div class="tabItem text-center cursor-pointer body-16_regular word4">
                    数字资产
                </div>
            </div>
            <div class="mobile scrollTabWrapper scroll-fade-up">
                <div class="scrollTab flex justify-center items-center">
                    <div class="tabItem text-center cursor-pointer md-footnote-regular_12 active word1">
                        衍生品
                    </div>
                    <div class="tabItem text-center cursor-pointer md-footnote-regular_12 word2">
                        贵金属及能源
                    </div>
                    <div class="tabItem text-center cursor-pointer md-footnote-regular_12 word3">
                        全球股指
                    </div>
                    <div class="tabItem text-center cursor-pointer md-footnote-regular_12 word4">
                        美国股票
                    </div>
                     <div class="tabItem text-center cursor-pointer body-16_regular word4">
                    ETF
                </div>
                <div class="tabItem text-center cursor-pointer body-16_regular word4">
                    数字资产
                </div>
                </div>
            </div>
            <div class="tableOverflowScrollContainer scroll-fade-up" style="position:relative">
                <div class="corner-mask mobile"></div>
                <div class="fake-scrollbar mobile">
                    <div class="fake-thumb"></div>
                </div>
                <div class="scrollTable">
                    <div class="contentBox safe-trading-table ">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th class="symbol-code body-16_medium md-body-14_medium">产品代码</th>
                                    <th class="body-16_medium md-body-14_medium">产品名称</th>
                                    <th class="body-16_medium md-body-14_medium">合约规模</th>
                                    <th class="body-16_medium md-body-14_medium">杠杆倍数</th>
                                    <th class="body-16_medium md-body-14_medium">保证金要求</th>
                                </tr>
                            </thead>
                            <tbody
                                class="body-14_regular md-body-14_medium tableTab1 showTbody largeTbody controlTBody">
                               
                                <tr class="tableShowMore">
                                    <td class="cursor-pointer">
                                        <span class="content-16_medium openList">查看所有产品</span>
                                        <span class="content-16_medium closeList">折叠列表</span>
                                        <span class="iconfont icon-a-down"></span>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody class="body-14_regular md-body-14_medium tableTab2"></tbody>
                            <tbody class="body-14_regular md-body-14_medium tableTab3"></tbody>
                            <tbody class="body-14_regular md-body-14_medium tableTab4 largeTbody controlTBody">
                              <tr class="tableShowMore">
                                    <td class="cursor-pointer">
                                        <span class="content-16_medium openList">查看所有产品</span>
                                        <span class="content-16_medium closeList">折叠列表</span>
                                        <span class="iconfont icon-a-down"></span>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody class="body-14_regular md-body-14_medium tableTab5 largeTbody controlTBody">
                              <tr class="tableShowMore">
                                    <td class="cursor-pointer">
                                        <span class="content-16_medium openList">查看所有产品</span>
                                        <span class="content-16_medium closeList">折叠列表</span>
                                        <span class="iconfont icon-a-down"></span>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody class="body-14_regular md-body-14_medium tableTab6"></tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="content-14_regular footerTip scroll-fade-up md-footnote-regular_12">*加密货币实行分级杠杆机制，持仓量不同杠杆等级不同，详询客服了解。</div>
            <a :href="signupUrl" target="_blank" class="safe-trading-btn scroll-fade-up">
                <div class="primary-default_large ">
                    开始投资
                </div>
            </a>
        </section>
        <open-account></open-account>
        <section class="container4">
            <div class="contentBox">
                <h2 class="scroll-fade-up word1">杠杆常见问题</h2>
                <div class="QA-list">
                    <div class="QA-item">
                        <div class="QA-title word2">1、什么是杠杆？</div>
                        <div class="QA-content">
                            <p class="QA-li word3">
                                杠杆是一种金融工具，‌允许投资者利用小额资金作为保证金，‌控制更大规模的资金进行交易。比如做等值
                                100,000 美元的交易，‌假设杠杆为 500 倍，只需有100,000/500 = 200
                                美元便可进行交易‌。杠杆的高低会直接决定所需保证金的大小。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title word4">2、初始杠杆是多少倍？</div>
                        <div class="QA-content">
                            <p class="QA-li word5">
                                EBC未设置固定的初始杠杆，开设账号时，可在平台提供的杠杆范围内，自主选择适合自己的杠杆倍数。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title word6">3、不同品种的最高杠杆是一样的吗？</div>
                        <div class="QA-content">
                            <p class="QA-li word7">
                                根据交易产品的不同，最高杠杆也会不同。比如欧元兑美元、黄金通常情况下最高杠杆是500倍，而小众货币对比如美元兑南非兰特只有50倍杠杆。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title word10">4、超级杠杆仅适用于哪些交易品种？</div>
                        <div class="QA-content">
                            <p class="QA-li word11">
                                仅限外汇、贵金属类交易产品可用，其他交易产品默认为标准杠杆。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title word12">
                            5、哪些类型的交易账号可以申请开通超级杠杆？
                        </div>
                        <div class="QA-content">
                            <p class="QA-li word13">
                                仅限真实交易账号，支持标准账号（STD）、专业账号（PRO），PAMM
                                账号不可用。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title word14">
                            6、账号净值低于或超过 2000美元时，超级杠杆会自动生效/失效吗？
                        </div>
                        <div class="QA-content">
                            <p class="QA-li word15">
                                账号净值低于2000美元需手动申请生效；超过2000美元会自动失效转标准杠杆，净值回落后需重新申请才能生效。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title word16">7、超级杠杆有时间段限制吗？</div>
                        <div class="QA-content">
                            <p class="QA-li word17">
                                为保障市场稳定，在每月重要经济数据（如美国非农、CPI、利率决议）、每周五收市前两小时及临时重大事件公布期间，超级杠杆将暂停生效，所有仓位暂用1:200杠杆。不生效时段结束后，该时段内开仓的订单将重新按超级杠杆计算保证金。请注意，此规则同样适用于普通杠杆。
                            </p>
                        </div>
                    </div>
                   
                    <div class="QA-item">
                        <div class="QA-title word20">
                            8、使用超级杠杆时，净值低于多少会触发强制平仓？
                        </div>
                        <div class="QA-content word21">
                            <p class="QA-li">超级杠杆生效时，账号净值 <0 时触发强制平仓；账号净值> 2000 美元时，超级杠杆自动失效，保证金比例 < 30% 时触发强制平仓。</p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title word20">
                            9.超级杠杆生效期间，有持仓时最大可出金额如何计算？
                        </div>
                        <div class="QA-content word21">
                            <p class="QA-li">有持仓时可出金额为 “账号净值与余额中较小值的 50%”，无持仓时可全额出金。</p>
                        </div>
                    </div>
                     <div class="QA-item">
                        <div class="QA-title word18">
                            10、为什么我的账号符合条件却没有开通超级杠杆的选项？
                        </div>
                        <div class="QA-content">
                            <p class="QA-li word19">
                                超级杠杆功能目前仅对部分地区开放，可联系客服咨询。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <message-v3></message-v3>

        <page-footer></page-footer>
    </div>
</template>

<script>
import WOW from 'wowjs';
import md5 from 'js-md5';
import fadeAnimate from "../mixins/fadeAnimate.js";
import { mapGetters } from "vuex";
import {
    mapState
} from "vuex";
export default {
    mixins: [fadeAnimate],
    data() {
        return {
        }
    },
    created() {
    },
    computed: {
        ...mapGetters(["signupUrl"]),
    },
    mounted() {
        this.initPage();
    },
    methods: {
        initPage() {
            var apiToken = "{$apiToken}";
            const link = document.querySelector('link[href*="/ebc-static/css/bootstrap.css"]');
            if (link) {
                link.remove();
            }
            const setTabActIdx = (idx, e) => {
                scrollTabElement.forEach((item, index) => {
                    item.classList.remove("active");
                })
                floatTabElement.forEach((item, index) => {
                    item.classList.remove("active");
                })
                floatTabElement[idx].classList.add("active");
                scrollTabElement[idx].classList.add("active");
                const rem = parseFloat(
                    getComputedStyle(document.documentElement).fontSize
                );
                const leftPad = 32 * rem;
                const wrapper = document.querySelector(".scrollTabWrapper");
                wrapper.scrollLeft =
                    idx <= 1 ? 0 : e.target.offsetLeft - leftPad;
            };
            const scrollTabElement = document.querySelectorAll('.scrollTabWrapper .tabItem')
            const floatTabElement = document.querySelectorAll('.floatTab .tabItem')
            const totalTableData = [
  [
    {
      enCode: 'AUDUSD',
      cnName: "澳元/美元",
      cnfName: "澳元/美元",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'EURUSD',
      cnName: "欧元/美元",
      cnfName: "歐元/美元",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'GBPUSD',
      cnName: "英镑/美元",
      cnfName: "英鎊/美元",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'NZDUSD',
      cnName: "纽元/美元",
      cnfName: "紐元/美元",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'USDCAD',
      cnName: "美元/加元",
      cnfName: "美元/加元",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'USDCHF',
      cnName: "美元/瑞郎",
      cnfName: "美元/瑞郎",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'USDJPY',
      cnName: "美元/日元",
      cnfName: "美元/日圓",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'GBPAUD',
      cnName: "英镑/澳元",
      cnfName: "英鎊/澳元",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'GBPJPY',
      cnName: "英镑/日元",
      cnfName: "英鎊/日圓",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'AUDCAD',
      cnName: "澳元/加元",
      cnfName: "澳元/加元",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'AUDCHF',
      cnName: "澳元/瑞郎",
      cnfName: "澳元/瑞郎",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'AUDJPY',
      cnName: "澳元/日元",
      cnfName: "澳元/日圓",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'AUDNZD',
      cnName: "澳元/纽元",
      cnfName: "澳元/紐元",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'CADCHF',
      cnName: "加元/瑞郎",
      cnfName: "加元/瑞郎",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'CADJPY',
      cnName: "加元/日元",
      cnfName: "加元/日圓",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'CHFJPY',
      cnName: "瑞郎/日元",
      cnfName: "瑞郎/日圓",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'EURAUD',
      cnName: "欧元/澳元",
      cnfName: "歐元/澳元",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'EURCAD',
      cnName: "欧元/加元",
      cnfName: "歐元/加元",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'EURCHF',
      cnName: "欧元/瑞郎",
      cnfName: "歐元/瑞郎",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'EURGBP',
      cnName: "欧元/英镑",
      cnfName: "歐元/英鎊",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'EURJPY',
      cnName: "欧元/日元",
      cnfName: "歐元/日圓",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'EURNZD',
      cnName: "欧元/纽元",
      cnfName: "歐元/紐元",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'GBPCAD',
      cnName: "英镑/加元",
      cnfName: "英鎊/加元",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'GBPCHF',
      cnName: "英镑/瑞郎",
      cnfName: "英鎊/瑞郎",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'GBPNZD',
      cnName: "英镑/纽元",
      cnfName: "英鎊/紐元",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'NZDCAD',
      cnName: "纽元/加元",
      cnfName: "紐元/加元",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'NZDCHF',
      cnName: "纽元/瑞郎",
      cnfName: "紐元/瑞郎",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'NZDJPY',
      cnName: "纽元/日元",
      cnfName: "紐元/日圓",
      contractModule: 100000,
      ruleMultiple: 500,
      ruleRate: "0.20%",
    },
    {
      enCode: 'USDCNH',
      cnName: "美元/离岸人民币",
      cnfName: "美元/離岸人民幣",
      contractModule: 100000,
      ruleMultiple: 50,
      ruleRate: "2.00%",
    },
    {
      enCode: 'USDHKD',
      cnName: "美元/港币",
      cnfName: "美元/港元",
      contractModule: 100000,
      ruleMultiple: 50,
      ruleRate: "2.00%",
    },
    {
      enCode: 'USDMXN',
      cnName: "美元/墨西哥比索",
      cnfName: "美元/墨西哥披索",
      contractModule: 100000,
      ruleMultiple: 50,
      ruleRate: "2.00%",
    },
    {
      enCode: 'USDNOK',
      cnName: "美元/挪威克朗",
      cnfName: "美元/挪威克朗",
      contractModule: 100000,
      ruleMultiple: 50,
      ruleRate: "2.00%",
    },
    {
      enCode: 'USDPLN',
      cnName: "美元/波兰兹罗提",
      cnfName: "美元/波蘭茲羅提",
      contractModule: 100000,
      ruleMultiple: 50,
      ruleRate: "2.00%",
    },
    {
      enCode: 'USDSEK',
      cnName: "美元/瑞典克朗",
      cnfName: "美元/瑞典克朗",
      contractModule: 100000,
      ruleMultiple: 50,
      ruleRate: "2.00%",
    },
    {
      enCode: 'USDSGD',
      cnName: "美元/新加坡元",
      cnfName: "美元/新加坡元",
      contractModule: 100000,
      ruleMultiple: 50,
      ruleRate: "2.00%",
    },
    {
      enCode: 'USDTRY',
      cnName: "美元/土耳其里拉",
      cnfName: "美元/土耳其里拉",
      contractModule: 100000,
      ruleMultiple: 50,
      ruleRate: "2.00%",
    },
    {
      enCode: 'USDZAR',
      cnName: "美元/南非兰特",
      cnfName: "美元/南非蘭特",
      contractModule: 100000,
      ruleMultiple: 50,
      ruleRate: "2.00%",
    },
  ],
  [
    {
      enCode: "XAGUSD",
      cnName: "白银/美元",
      cnfName: "白銀/美元",
      contractModule: 5000,
      ruleMultiple: "500",
      ruleRate: "0.20%",
    },
    {
      enCode: "XAUUSD",
      cnName: "黄金/美元",
      cnfName: "黃金/美元",
      contractModule: 100,
      ruleMultiple: "500",
      ruleRate: "0.20%",
    },
    {
      enCode: "XBRUSD",
      cnName: "布伦特原油",
      cnfName: "布倫特原油",
      contractModule: 1000,
      ruleMultiple: "100",
      ruleRate: "1.00%",
    },
    {
      enCode: "XNGUSD",
      cnName: "天然气",
      cnfName: "天然氣",
      contractModule: 10000,
      ruleMultiple: "50",
      ruleRate: "2.00%",
    },
    {
      enCode: "XTIUSD",
      cnName: "WTI原油",
      cnfName: "WTI原油",
      contractModule: 1000,
      ruleMultiple: "100",
      ruleRate: "1.00%",
    },
  ],
  [
    {
      enCode: "100GBP",
      cnName: "富时100指数",
      cnfName: "富時100指數",
      contractModule: 10,
      ruleMultiple: 100,
      ruleRate: "1.00%",
    },
    {
      enCode: "200AUD",
      cnName: "S&P200指数",
      cnfName: "S&P200指數",
      contractModule: 10,
      ruleMultiple: 100,
      ruleRate: "1.00%",
    },
    {
      enCode: "225JPY",
      cnName: "日经225指数",
      cnfName: "日經225指數",
      contractModule: 100,
      ruleMultiple: 100,
      ruleRate: "1.00%",
    },
    {
      enCode: "CNIUSD",
      cnName: "中国A50指数",
      cnfName: "中國A50指數",
      contractModule: 10,
      ruleMultiple: 100,
      ruleRate: "1.00%",
    },
    {
      enCode: "D30EUR",
      cnName: "DAX30指数",
      cnfName: "DAX30指數",
      contractModule: 10,
      ruleMultiple: 100,
      ruleRate: "1.00%",
    },
    {
      enCode: "E50EUR",
      cnName: "STOXX50指数",
      cnfName: "STOXX50指數",
      contractModule: 10,
      ruleMultiple: 100,
      ruleRate: "1.00%",
    },
    {
      enCode: "F40EUR",
      cnName: "CAC40指数",
      cnfName: "CAC40指數",
      contractModule: 10,
      ruleMultiple: 100,
      ruleRate: "1.00%",
    },
    {
      enCode: "HSIHKD",
      cnName: "恒生指数",
      cnfName: "恒生指數",
      contractModule: 10,
      ruleMultiple: 100,
      ruleRate: "1.00%",
    },
    {
      enCode: "NASUSD",
      cnName: "纳斯达克指数",
      cnfName: "納斯達克指數",
      contractModule: 10,
      ruleMultiple: 100,
      ruleRate: "1.00%",
    },
    {
      enCode: "RUTUSD",
      cnName: "罗素2000指数",
      cnfName: "羅素2000指數",
      contractModule: 100,
      ruleMultiple: 100,
      ruleRate: "1.00%",
    },
    {
      enCode: "SPXUSD",
      cnName: "标普500指数",
      cnfName: "標普500指數",
      contractModule: 100,
      ruleMultiple: 100,
      ruleRate: "1.00%",
    },
    {
      enCode: "U30USD",
      cnName: "道琼斯指数",
      cnfName: "道瓊斯指數",
      contractModule: 10,
      ruleMultiple: 100,
      ruleRate: "1.00%",
    },
  ],
  [
    {
      enCode: "PABT.N",
      enName: "ABT.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PBA.N",
      enName: "BA.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PBAC.N",
      enName: "BAC.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PBMY.N",
      enName: "BMY.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PCAT.N",
      enName: "CAT.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PCRM.N",
      enName: "CRM.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PCVX.N",
      enName: "CVX.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PDIS.N",
      enName: "DIS.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PGE.N",
      enName: "GE.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PGS.N",
      enName: "GS.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PHD.N",
      enName: "HD.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PIBM.N",
      enName: "IBM.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PJNJ.N",
      enName: "JNJ.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PJPM.N",
      enName: "JPM.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PKO.N",
      enName: "KO.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PLLY.N",
      enName: "LLY.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PLMT.N",
      enName: "LMT.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PMA.N",
      enName: "MA.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PMCD.N",
      enName: "MCD.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PMDT.N",
      enName: "MDT.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PMMM.N",
      enName: "MMM.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PMRK.N",
      enName: "MRK.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PMS.N",
      enName: "MS.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PNEE.N",
      enName: "NEE.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PPFE.N",
      enName: "PFE.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PPG.N",
      enName: "PG.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PRTX.N",
      enName: "RTX.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PUNH.N",
      enName: "UNH.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PV.N",
      enName: "V.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PVZ.N",
      enName: "VZ.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PWMT.N",
      enName: "WMT.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PXOM.N",
      enName: "XOM.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PAAPL.OQ",
      enName: "AAPL.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PADBE.OQ",
      enName: "ADBE.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PAMGN.OQ",
      enName: "AMGN.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PAMZN.OQ",
      enName: "AMZN.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PBRKb.N",
      enName: "BRKb.N",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PCMCSA.OQ",
      enName: "CMCSA.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PCSCO.OQ",
      enName: "CSCO.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PGLD.P",
      enName: "GLD.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PGOOGL.OQ",
      enName: "GOOGL.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PHON.OQ",
      enName: "HON.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PINTC.OQ",
      enName: "INTC.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PMETA.OQ",
      enName: "META.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PMSFT.OQ",
      enName: "MSFT.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PNFLX.OQ",
      enName: "NFLX.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PNVDA.OQ",
      enName: "NVDA.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PPEP.OQ",
      enName: "PEP.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PPYPL.OQ",
      enName: "PYPL.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PTSLA.OQ",
      enName: "TSLA.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PTXN.OQ",
      enName: "TXN.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
  ],
  [
    {
      enCode: "AGG.P",
      enName: "AGG.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "BIL.P",
      enName: "BIL.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "BSV.P",
      enName: "BSV.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "DGRO.P",
      enName: "DGRO.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "DIA.P",
      enName: "DIA.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "EEM.P",
      enName: "EEM.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "EFA.P",
      enName: "EFA.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "EWT.P",
      enName: "EWT.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "EWW.P",
      enName: "EWW.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "EWY.P",
      enName: "EWY.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "EWZ.P",
      enName: "EWZ.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "FVD.P",
      enName: "FVD.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "FXI.P",
      enName: "FXI.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "GDX.P",
      enName: "GDX.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "GDXJ.P",
      enName: "GDXJ.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "GLD.P",
      enName: "GLD.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "HDV.P",
      enName: "HDV.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "HYG.P",
      enName: "HYG.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IEMG.P",
      enName: "IEMG.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IJH.P",
      enName: "IJH.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IJR.P",
      enName: "IJR.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "ITOT.P",
      enName: "ITOT.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IVE.P",
      enName: "IVE.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IVV.P",
      enName: "IVV.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IVW.P",
      enName: "IVW.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IWB.P",
      enName: "IWB.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IWD.P",
      enName: "IWD.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IWF.P",
      enName: "IWF.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IWM.P",
      enName: "IWM.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IWN.P",
      enName: "IWN.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IWS.P",
      enName: "IWS.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "LQD.P",
      enName: "LQD.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "MDY.P",
      enName: "MDY.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "RSP.P",
      enName: "RSP.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "SCHB.P",
      enName: "SCHB.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "SCHD.P",
      enName: "SCHD.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "SCHF.P",
      enName: "SCHF.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "SCHG.P",
      enName: "SCHG.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "SCHX.P",
      enName: "SCHX.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "SDY.P",
      enName: "SDY.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "SPDW.P",
      enName: "SPDW.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "SPY.P",
      enName: "SPY.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "SPYG.P",
      enName: "SPYG.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "SPYV.P",
      enName: "SPYV.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "TIP.P",
      enName: "TIP.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "UNG.P",
      enName: "UNG.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "URA.P",
      enName: "URA.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "USO.P",
      enName: "USO.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VB.P",
      enName: "VB.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VDE.P",
      enName: "VDE.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VEA.P",
      enName: "VEA.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VEU.P",
      enName: "VEU.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VGT.P",
      enName: "VGT.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VHT.P",
      enName: "VHT.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VIG.P",
      enName: "VIG.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VNQ.P",
      enName: "VNQ.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VO.P",
      enName: "VO.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VOE.P",
      enName: "VOE.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VOO.P",
      enName: "VOO.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VT.P",
      enName: "VT.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VTI.P",
      enName: "VTI.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VTV.P",
      enName: "VTV.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VUG.P",
      enName: "VUG.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VWO.P",
      enName: "VWO.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VXF.P",
      enName: "VXF.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VYM.P",
      enName: "VYM.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "XLB.P",
      enName: "XLB.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "XLE.P",
      enName: "XLE.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "XLF.P",
      enName: "XLF.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "XLI.P",
      enName: "XLI.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "XLK.P",
      enName: "XLK.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "XLP.P",
      enName: "XLP.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "XLU.P",
      enName: "XLU.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "XLV.P",
      enName: "XLV.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "XLY.P",
      enName: "XLY.P",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "AAXJ.OQ",
      enName: "AAXJ.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "ACWI.OQ",
      enName: "ACWI.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "BND.OQ",
      enName: "BND.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "BNDX.OQ",
      enName: "BNDX.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "DVY.OQ",
      enName: "DVY.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "EMB.OQ",
      enName: "EMB.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IBB.OQ",
      enName: "IBB.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "ICLN.OQ",
      enName: "ICLN.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IEI.OQ",
      enName: "IEI.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "INDY.OQ",
      enName: "INDY.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IUSG.OQ",
      enName: "IUSG.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "IUSV.OQ",
      enName: "IUSV.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "MCHI.OQ",
      enName: "MCHI.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "PFF.OQ",
      enName: "PFF.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "QQQ.OQ",
      enName: "QQQ.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "SHV.OQ",
      enName: "SHV.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "SHY.OQ",
      enName: "SHY.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "SKYY.OQ",
      enName: "SKYY.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "SMH.OQ",
      enName: "SMH.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "SOXX.OQ",
      enName: "SOXX.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "TLT.OQ",
      enName: "TLT.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "TQQQ.OQ",
      enName: "TQQQ.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VCIT.OQ",
      enName: "VCIT.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VCSH.OQ",
      enName: "VCSH.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
    {
      enCode: "VXUS.OQ",
      enName: "VXUS.OQ",
      contractModule: 1,
      ruleMultiple: 5,
      ruleRate: "20.00%",
    },
  ],
  [
    {
      enCode: "BTCUSD",
      enName: "BTCUSD",
      cnName: "比特币",
      cnfName: "比特幣",
      contractModule: 1,
      ruleMultiple: 200,
      ruleRate: "0.50%",
    },
  ],
];
if(window.matchMedia('(max-width:996px)').matches){
  document.querySelectorAll(".largeTbody").forEach(i=>i.classList.remove("controlTBody"));
  document.querySelectorAll('tbody').forEach(tbody => {
    tbody.innerHTML = ''
  })
}

function prependQuoteRows(list, tbody,scopeHash,index) {
  if (!tbody) { console.warn('未找到 tbody'); return; }
  const frag = document.createDocumentFragment();
  
  list.forEach(data => {
    const tr = document.createElement('tr');
    tr.setAttribute(scopeHash, '');
    [
      data.enCode,
      (location.href.includes('/zh-cn/') ? data.cnName : location.href.includes('/zh/') ? data.cnfName : data.enName) || data.enCode,
      data.contractModule.toLocaleString(),
      data.ruleMultiple+ (index==5?'<span style="display:inline-block">*</span>':''),
      data.ruleRate+ (index==5?'<span style="display:inline-block">*</span>':'')
    ].forEach(text => {
      const td = document.createElement('td');
      td.innerHTML = text;
      td.setAttribute(scopeHash, '');
      tr.appendChild(td);
    });

    frag.appendChild(tr);   // 先放进片段
  });

  // 3. 插入逻辑：已有行则插到第一行前面，否则直接追加
  const firstRow = tbody.querySelector('tr');
  if (firstRow) {
    tbody.insertBefore(frag, firstRow);
  } else {
    tbody.appendChild(frag);
  }
}
document.querySelectorAll('tbody').forEach((tbody,index) => {
    const templateTr = document.querySelector('tbody .tableShowMore');   // 任一行
const scopeHash = templateTr?.getAttributeNames()
              .find(n => n.startsWith('data-v-')) || '';
    prependQuoteRows(totalTableData[index], tbody,scopeHash,index)
});
            floatTabElement.forEach((item, index) => {
              
                let floatTabtopNum = document.querySelector('.safe-trading-title').offsetTop + 80
                item.addEventListener('click', (e) => {
                   if(index == 5){
                  document.querySelector('.footerTip').classList.add('showFooterTip')
                }else {
                  document.querySelector('.footerTip').classList.remove('showFooterTip')
                }
                    setTabActIdx(index, e);
                    document.querySelector('.showTbody').classList.remove('showTbody');
                    let tabDom = document.querySelector('.tableTab' + (index + 1));
                    tabDom.classList.add('showTbody')
                    window.scrollTo({
                        top: floatTabtopNum,
                    })
                })
            })
            scrollTabElement.forEach((item, index) => {
              
                item.addEventListener('click', (e) => {
                  if(index == 5){
                  document.querySelector('.footerTip').classList.add('showFooterTip')
                }else {
                  document.querySelector('.footerTip').classList.remove('showFooterTip')
                }
                    setTabActIdx(index, e);
                    document.querySelector('.showTbody').classList.remove('showTbody');
                    let tabDom = document.querySelector('.tableTab' + (index + 1));
                    tabDom.classList.add('showTbody')
                })
            })

            function syncFakeScroll(wrapperSel) {
                const wrap = document.querySelector(wrapperSel);
                const scroll = wrap.querySelector(".scrollTable");
                const innerTable = wrap.querySelector(".safe-trading-table");
                const track = wrap.querySelector(".fake-scrollbar");
                const thumb = wrap.querySelector(".fake-thumb");

                function sync() {
                    const w = scroll.clientWidth;
                    const sw = scroll.scrollWidth;
                    const l = scroll.scrollLeft;
                    const maxL = sw - w;
                    if (maxL <= 0) {
                        thumb.style.width = "100%";
                        return;
                    }

                    const thumbW = (w / sw) * track.clientWidth;
                    thumb.style.width = thumbW + "px";
                    const maxMove = track.clientWidth - thumbW;
                    thumb.style.transform = `translateX(${(l / maxL) * maxMove}px)`;
                    if (l <= 0) {
                        wrap.classList.add("noScroll");
                    } else {
                        wrap.classList.remove("noScroll");
                    }
                }

                scroll.addEventListener("scroll", sync, { passive: true });
                const ro = new ResizeObserver(entries => {
                    for (const e of entries) {
                        scroll.scrollLeft = 0;
                        thumb.style.transform = `translateX(0)`;
                        wrap.classList.add("noScroll");
                        setTimeout(() => {
                            sync();
                        })
                    }
                });
                ro.observe(innerTable);
                sync();
            }
            // 用法
            syncFakeScroll(".tableOverflowScrollContainer");
            document.querySelectorAll('.tableShowMore').forEach((i,index)=>i.addEventListener('click', function () {
                document.querySelectorAll('.largeTbody')[index].classList.toggle('controlTBody');
            }))

            function initPublicContainer4Class() {
                document
                    .querySelector(".container4 h2")
                    .classList.add("title-48_bold", "md-title-24_bold");
                document.querySelectorAll(".container4 .QA-title").forEach((i) => {
                    i.classList.add("subtitle-18_medium", "md-body-16_medium");
                });
                document.querySelectorAll(".container4 .QA-li").forEach((i) => {
                    i.classList.add("content-16_regular", "md-content-14_regular");
                });
            }
            initPublicContainer4Class();
            let expendSpan = document.querySelectorAll(".QA-item .QA-title");
            expendSpan.forEach((item) => {
                item.insertAdjacentHTML(
                    "beforeend",
                    '<span class="iconfont icon-show"></span><span class="iconfont icon-close2"></span>'
                );
                item.addEventListener("click", function () {
                    this.parentNode.classList.toggle("showList");
                });
            });
        },
    }
}
</script>

<style scoped>
.tableShowMore {
    padding: 22rem 0;
    display: flex;
    justify-content: center;
}
.tableShowMore,.tableShowMore td{
    color: #A52933 !important;
}
.tableShowMore .iconfont {
    margin-left: 4rem;
}

.tableShowMore:hover td ,.tableShowMore:hover {
    background: #fff!important;
}

.controlTBody tr:nth-child(n+11) {
    display: none;
}

.controlTBody tr:last-child {
    display: flex !important;
}

.iconfont.icon-a-down {
    transform: rotate(180deg);
    display: inline-block;
}

.controlTBody .iconfont.icon-a-down {
    transform: rotate(0deg);
    display: inline-block;
}

.contentBox {
    max-width: 1200rem;
    margin-inline: auto;
}

.leverage-margin_header {
    background: #ebebeb;
    padding-top: 96rem;
    min-height: 560rem;
      gap: 108rem;
    padding-left: calc(50vw - 600rem)
}

.leverage-margin_main {
      padding-top: 64rem;
    flex: 0 0 588rem;
}

.leverage-margin_title {}

.leverage-margin_desc {
    color: var(--ebc-text-secondary);
    margin: 24rem 0 64rem;
}

.leverage-margin_btn {
    width: fit-content;
    min-width: 180rem;
}

.leverage-margin_model {
      height: 405rem;
}

.icon-right {
    display: inline-block;
    margin-left: 5rem;
}

.openList {
    display: none;
}

.closeList {
    display: inline-block;
}

.controlTBody .openList {
    display: inline-block;
}

.controlTBody .closeList {
    display: none;
}
.superLeverBtn{
    padding:16rem 0;
    margin-top: 40rem;
    color: #fff;
    display: inline-block;
    margin-inline: auto;
    opacity: .8;
}
.superLeverBtn:hover{
    opacity: 1;
}
@media (min-width:996px) {

    .ar table tr td:first-child,
    .ar table tr th:first-child {
        text-align: right;
    }

    .ar table tr td:last-child,
    .ar table tr th:last-child {
        text-align: left;
    }

    .ar .leverage-margin_header {
        padding-right: calc(50vw - 600rem);
        padding-left: 0;

    }

    .vi .leverage-margin_main,
    .th .leverage-margin_main,
    .ug .leverage-margin_main {
        flex: 0 0 658rem;
    }

    .ru h1,
    .vi h1,
    .ug h1 {
        font-size: 72rem;
        line-height: 76rem;
    }

    .vi .leverage-margin_model,
    .th .leverage-margin_model,
    .ug .leverage-margin_model {
        margin-left: -70rem;
    }

    .ar .leverage-margin_main,
    .en .leverage-margin_main,
    .es .leverage-margin_main,
    .id .leverage-margin_main,
    .mn .leverage-margin_main,
    .pt .leverage-margin_main,
    .ru .leverage-margin_main {
        flex: 0 0 688rem;
    }

    .es h1,
    .mn h1,
    .pt h1 {
        font-size: 68rem;
        line-height: 74rem;
    }

    .ar h1,
    .en h1,
    .id h1 {
        font-size: 74rem;
    }

    .ar .leverage-margin_model,
    .en .leverage-margin_model,
    .es .leverage-margin_model,
    .id .leverage-margin_model,
    .mn .leverage-margin_model,
    .pt .leverage-margin_model,
    .ru .leverage-margin_model {
        margin-left: -100rem;
    }

    .es .leverage-margin_desc,
    .mn .leverage-margin_desc,
    .ru .leverage-margin_desc {
        margin-bottom: 32rem;
        font-size: 16rem;
    }

    .pt .leverage-margin_desc {
        margin-bottom: 32rem;
    }
}

.footerTip{
    display: none;
  color: var(--ebc-text-tertiary);
  margin-top: -36rem;
  margin-bottom: 60rem;
  width: 1200rem;
  margin-inline: auto;
}
.showFooterTip{
    display: block;
}
@media (max-width: 996px) {
.superLeverBtn{
  margin-top: 32rem;
}
.footerTip{
    margin-top: -32rem;
    width: calc( 100% - 64rem);
    margin-inline:32rem;
}
    .tableShowMore {
        display: none;
    }

    #page-navigate {
        background: #fff !important;
    }

    section {
        padding-inline: 32rem !important;
    }

    .leverage-margin_header {
        flex-direction: column;
        gap: 0;
        align-items: center;
        padding-bottom: 80rem;
        padding-top: 0;
        overflow: hidden;
    }

    .leverage-margin_main {
        order: 2;
        text-align: center;
        padding-top: 30rem;
        flex-basis: unset;
    }

    .leverage-margin_model {
        height: 514rem;
        /* margin-left: -110rem; */
        margin-top: 30rem;
    }

    .ar .leverage-margin_model {
        margin-left: unset;
        margin-right: -100rem;
    }

    .leverage-margin_desc {
        margin: 16rem 0 64rem;
    }

    .leverage-margin_btn {
        width: 100%;
        gap: 8rem;
    }
}

.safe-trading {
    padding: 120rem 0;
    background: #fff;
}

.safe-trading-desc {
    color: var(--ebc-text-secondary);
    margin: 16rem auto 60rem;
}

.floatTab {
    position: sticky;
    z-index: 99999;
    top:calc(128px - 28rem);
    margin-inline: auto;
    background:var(--ebc-neutral-bg_a);
    border-radius: var(--ebc-corner-radius-full);
    color:var(--ebc-text-secondary);
    backdrop-filter: blur(10px);
    padding: 4rem;
    gap: 4rem;
    width: 800rem;
    height:64rem;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
}

.floatTab .tabItem {
    flex:1;
  color: var(--ebc-text-secondary);
  height:100%;
  line-height: 56rem;
}

.floatTab .active {
     border-radius: var(--ebc-corner-radius-full);
    background: var(--ebc-neutral-bg_c);
    color:var(--ebc-text-primary);
    display:flex;
    align-items: center;
    justify-content: center;
    height:100%;
    font-weight: 500;
}

.safe-trading-table {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: var(--ebc-corner-radius-rc16);
    margin: 40rem auto 60rem;
    overflow: hidden;
}

table,
tr,
thead,
tbody {
    display: block;
    width: 100%;
    box-sizing: border-box;
}

table tr {
    padding: 24rem;
    display: flex;
}

table tr td,
table tr th {
    flex: 1;
    box-shadow: none;
    text-align: center;
}

table thead {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

table tr td {
    text-align: center;
}

table tr td:nth-child(4),
table tr td:nth-child(5) {
    color: var(--ebc-brand-secondary-red);
    font-size: 16rem;
    font-weight: 500;
}





table thead ,table thead th{
    background: var(--ebc-neutral-bg_c)
}

table tbody {
    display: none;
}

table tbody tr:hover,table tbody tr:hover td {
    background: var(--ebc-neutral-bg_b);
}

table .showTbody {
    display: inline-block;
}

.safe-trading-btn {
    min-width: 180rem;
    width: fit-content;
    display: block;
    margin-inline: auto;
}

@media screen and (max-width: 996px) {
.scrollTable table tbody tr.tableShowMore{
        display: none!important;
    }
    html {
        height: auto !important;
        min-height: auto !important;
    }

    .safe-trading {
        padding: 160rem 0 !important;
    }

    .safe-trading-title,
    .safe-trading-desc,
    .scrollTabWrapper {
        padding-inline: 32rem !important;
    }

    .safe-trading-table {
        width: fit-content;
        max-width: unset !important;
        overflow: auto;
        overflow-x: auto;
        border: 0;
        border-radius: 32rem;
        position: relative;
        overflow: visible;
        margin: 0!important;
        margin-right: 32rem !important;
    }

    .scrollTable {
        margin: 48rem 32rem 128rem 32rem !important;
        overflow: auto;
    }

    .scrollTable::-webkit-scrollbar {
        display: none;
    }

    .safe-trading-desc {
        margin: 16rem 0 80rem;
    }

    .floatTab {
        display: none !important;
    }

    .corner-mask {
        position: absolute;
        left: 20rem;
        width: 25px;
        height: 100%;
        background: #fff;
        z-index: 2;
        pointer-events: none;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
    }

    table .showTbody {
        display: flex;
    }

    table tr {
        display: flex;
        flex-direction: column;
    }

    table {
        display: flex;
        justify-content: flex-start;
    }

    table,
    tbody {
        width: fit-content;
    }

    table thead {
        flex: 0 0 204rem;
        border: 0;
        position: sticky;
        left: 0;
        z-index: 3;
        background: none;
        text-align: left;
    }

    .enTable table thead tr {
        width: 250rem;
    }

    .enTable table tr th:last-child {
        text-align: left;
        padding: 26rem;
    }

    table th {
        overflow: hidden;
        background: var(--ebc-neutral-bg_c);
        border-left: 1px solid rgba(0, 0, 0, 0.12);
        border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
        border-right: 1px solid rgba(0, 0, 0, 0.12);
        white-space: nowrap;
    }

    table th:first-child {
        border-top-left-radius: 32rem;
    }

    table tr:last-child td:first-child {
        border-top-right-radius: 32rem;

    }

    table tr:last-child td:last-child {
        border-bottom-right-radius: 32rem;

    }

    table th:last-child {
        border-bottom-left-radius: 32rem;
    }

    table th:first-child,
    table td:first-child {
        border-top: 1px solid rgba(0, 0, 0, 0.12);

    }

    table th::after {
        content: '';
        position: absolute;
        top: 0;
        right: -8px;
        width: 8px;
        height: 100%;
        background: linear-gradient(to right, rgba(0, 0, 0, 0.04), transparent);
        pointer-events: none;
    }

    .noScroll table th::after {
        display: none;
    }

    table tr {
        padding: 0;
    }

    table tbody tr {
        min-width: 240rem;
        flex: 1 0 240rem;
    }

    table tbody tr td {
        padding: 48rem 32rem;
        text-align: left;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
        border-right: 1px solid rgba(0, 0, 0, 0.12);
        white-space: nowrap
    }

    table thead th {
        padding: 48rem 32rem;
    }

    table tr td:nth-child(4),
    table tr td:nth-child(5) {
        font-size: 32rem;
        text-align: left;
    }

    .safe-trading-btn div {
        height: 80rem;
        font-size: 28rem;
        line-height: 0;
    }

    .scrollTab {
        display: inline-flex;
        gap: 16rem;
        min-width: fit-content;
        width: 100%;
    }

    .scrollTabWrapper {
        overflow-x: auto;
        scroll-behavior: smooth;
        margin-top: 64rem;
        background: var(--ebc-neutral-bg_a);
        position: sticky;
        top: 44px;
        z-index: 99
    }

    .scrollTabWrapper::-webkit-scrollbar {
        display: none;
    }

    .scrollTab .tabItem {
        color: var(--ebc-text-secondary);
        padding: 16rem 32rem;
        flex: 1;
        background: var(--ebc-neutral-bg_b);
        border-radius: var(--ebc-corner-radius-full);
        white-space: nowrap;
    }

    .scrollTab .active {
        background: var(--ebc-basecolor-active-500);
        color: var(--ebc-text-primary_white);
        font-weight: 500;
    }

    table tbody tr:hover {
        background: var(--ebc-text-primary_white);
    }

    /* 伪滚动条容器 */
    .fake-scrollbar {
        position: absolute;
        left: 32rem;
        right: 32rem;
        bottom: -40rem;
        height: 4px;
        background: rgba(0, 0, 0, .1);
        border-radius: 2px;
        pointer-events: none;
        /* 只看不点 */
    }

    /* 伪滑块 */
    .fake-thumb {
        height: 100%;
        background: rgba(0, 0, 0, .4);
        border-radius: 2px;
        width: 0;
        /* js 动态算 */
        transition: width .2s;
    }


}

.superLever {
    background: url('../assets/image/LeverageAndMargin/superleverBg.png');
    background-size: 100% 100%;
    /* border-radius: 64rem 64rem 0 0; */
    padding: 80rem calc(50vw - 600rem);
    overflow: hidden;
    /* display: none!important; */
}

.superLever-title {
    gap: 16rem;
    color: #fff;
}

.superLever-title img {
    width: 24rem;
    height: 24rem;
}

.superLever-desc {
    margin: 16rem 0 48rem;
    color: var(--ebc-text-secondary_white);
}

.superLever-cardList {
    gap: 24rem;
    color: #fff;
    align-items: stretch !important;
}

.superLever-card-left {
    padding: 24rem;
    background: rgba(255, 255, 255, 0.08);
    flex: 0 0 588rem;
    border-radius: var(--ebc-corner-radius-rc16);
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);
    display: flex;
    flex-direction: column;
}

.superLever-card-title {
    gap: 16rem
}

.superLever-card-title img {
    max-width: 32rem;
}

.superLever-card-desc {
    margin: 16rem 0;
    color: var(--ebc-text-secondary_white)
}

.superLever-card-leverTypeList {
    gap: 16rem;
    align-items: stretch !important;
    margin: auto 0
}

.superLever-card-leverType {
    border-radius: var(--ebc-corner-radius-rc08);
    border: 0.5px solid rgba(255, 255, 255, 0.1);
    background: linear-gradient(303deg, rgba(62, 62, 74, 0.50) 30.52%, rgba(77, 77, 89, 0.50) 100%);
    padding: 16rem;
    position: relative;
    flex: 1;
    overflow: hidden;
}

.superLever-card-leverTypeNum {
    margin: 8rem 0 16rem;
}

.superLever-card-leverType .innerNumberBg {
    position: absolute;
    bottom: 12rem;
    right: 8rem;
    height: 124rem;
    width: auto;
}

.superLever-card-leverType .swWord {
    color: var(--ebc-text-secondary_white);
}

.superLever-card-leverType:nth-child(2) .innerNumberBg {
    right: -12rem;
}

.superLever-card-right {
    display: flex;
    flex-direction: column;
    gap: 24rem;
    -webkit-backdrop-filter: blur(25px);
    backdrop-filter: blur(25px);
}

.superLever-card-rightTop,
.superLever-card-rightBottom {
    padding: 24rem;
    flex: 1;
    background: rgba(255, 255, 255, 0.08);
    border-radius: var(--ebc-corner-radius-rc16);

}

.superLever-card-rightTop .superLever-card-desc,
.superLever-card-rightBottom .superLever-card-desc {
    margin-bottom: 0;
}

@media (min-width: 996px) {
    .mn .superLever-card-leverTypeNum {
        font-size: 36rem;
    }
}

@media (max-width: 996px) {
    .superLever {
        padding: 80rem 32rem;
        background: url('../assets/image/LeverageAndMargin/superleverBgM.png');
        background-size: 100% 100%;
    }

    .superLever-title {
        gap: 32rem;
    }

    .superLever-title img {
        width: 32rem;
        height: 32rem;
    }

    .superLever-cardList {
        flex-direction: column;

    }

    .superLever-card-left,
    .superLever-card-rightTop,
    .superLever-card-rightBottom {
        flex: 1;
        padding: 32rem;
    }

    .superLever-card-title {
        gap: 16rem;
    }

    .superLever-card-title img {
        max-width: 48rem;
        height: auto;
    }

    .superLever-card-desc {
        margin: 32rem 0;
    }

    .superLever-card-leverTypeList {
        flex-direction: column;
        gap: 32rem;
        flex: 1;
    }

    .superLever-card-leverType {
        width: 100%;
        padding: 32rem;
        border-radius: 8rem;
        background: linear-gradient(303deg, rgba(62, 62, 74, 0.50) 30.52%, rgba(77, 77, 89, 0.50) 100%);
    }

    .superLever-card-leverTypeNum {
        margin: 8rem 0 32rem;
    }

    .superLever-card-leverType .innerNumberBg {
        right: 16rem;
        bottom: 10rem;
        height: 248rem;
        width: auto;
    }

    .superLever-card-leverType:nth-child(2) .innerNumberBg {
        right: -24rem;
    }

    .superLever-card-right .superLever-card-desc {
        margin-bottom: 0;
    }

    .ru .superLever-title span {
        font-size: 43rem;
    }
}

.container4 {
    padding: 120rem 0;
    background: var(--ebc-basecolor-white-100);
    text-align: center;
}

.container4 .QA-list {
    margin-top: 60rem;
}

.container4 .QA-list .QA-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    padding: 24rem;
}

.container4 .QA-list .QA-item .QA-title span:first-child {
    display: inline;
}

.container4 .QA-list .QA-item .QA-title span:nth-child(2) {
    display: none;
}

.container4 .QA-list .QA-item.showList .QA-title span:first-child {
    display: none;
}

.container4 .QA-list .QA-item.showList .QA-title span:nth-child(2) {
    display: inline;
}

.container4 .QA-list .QA-item .QA-content {
    height: 0;
    overflow: hidden;
}

.container4 .QA-list .QA-item.showList .QA-content {
    height: auto;
}

.container4 .QA-list .QA-title {
    text-align: left;
    display: flex;
    cursor: pointer;
}

.ar .container4 .QA-list .QA-title span {
    margin-left: unset;
    margin-right: auto;
}

.container4 .QA-list .QA-title span {
    margin-left: auto;
    font-size: 28rem;
}

.container4 .QA-list .QA-li {
    text-align: left;
    color: var(--ebc-text-secondary);
    position: relative;
    padding-left: 18rem;
    margin-top: 10rem;
}

.container4 .QA-list .QA-li:first-child {
    margin-top: 24rem;
}

.container4 .QA-list .QA-li::before {
    content: "•";
    position: absolute;
    left: 0;
    top: 14rem;
    /* 根据 line-height 调整，使其在第一行中间 */
    transform: translateY(-50%);
    font-size: 16rem;
    line-height: 0;
    color: var(--ebc-text-secondary);
}

.ar .container4 .QA-list .QA-title {
    text-align: right;
}

.ar .container4 .QA-list .QA-li {
    padding-left: 0;
    padding-right: 18rem;
    text-align: right;
}

.ar .container4 .QA-list .QA-li::before {
    left: unset;
    right: 0;
}

@media (max-width: 996px) {
    .container4 {
        padding: 160rem 32rem;
    }

    .container4 .QA-list {
        margin-top: 80rem;
    }

    .container4 .QA-list .QA-item {
        padding: 40rem 0;
    }

    .container4 .QA-list .QA-title span {
        font-size: 42rem;
    }

    .container4 .QA-list .QA-li {
        padding-left: 32rem;
        margin-top: 25rem;
    }

    .ar .container4 .QA-list .QA-li {
        padding-left: 0;
        padding-right: 32rem;
    }

    .container4 .QA-list .QA-li:first-child {
        margin-top: 40rem;
    }

    .container4 .QA-list .QA-li::before {
        top: 24rem;
        /* 根据 line-height 调整，使其在第一行中间 */
        transform: translateY(-50%);
        font-size: 32rem;
    }
}
</style>
<style lang="scss">

.leverage-and-margin .container4 .QA-list .QA-item .QA-title span:first-child{
  display: inline;
}
.leverage-and-margin .container4 .QA-list .QA-item .QA-title span:nth-child(2){
  display: none;
}
.leverage-and-margin .container4 .QA-list .QA-item.showList .QA-title span:first-child{
  display: none;
}
.leverage-and-margin .container4 .QA-list .QA-item.showList .QA-title span:nth-child(2){
  display: inline;
}
.leverage-and-margin .container4 .QA-list .QA-title span{
  margin-left: auto;
  font-size: 28rem;
}
@media (max-width:996px){
.leverage-and-margin .container4 .QA-list .QA-title span{
  font-size: 42rem;
}
}
.leverage-and-margin{
    
}
</style>
